import { toString } from 'lodash/fp'

export const VERSION = require('../../package.json').version

export const GALLERY_URL = toString(process.env.REACT_APP_GALLERY_URL)
export const COOKIE_CONSENT_STATUS_KEY = 'lovejunk-cookie-consent-status'
export const COOKIE_CONSENT_STATUS_QUERY_PARAM_KEY = 'lvj-ccs'
